import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthenticationService } from '../rest/authentication.service';
import { environment } from '../../../../environments/environment';
import { from, switchMap } from 'rxjs';

const API_PREFIX = `${environment.apiUrl}/${environment.apiVersion}`;

export const authenticationInterceptorFn: HttpInterceptorFn = (req, next) =>
  from(inject(AuthenticationService).getJwtAccessToken()).pipe(
    switchMap((token) => {
      const needsAuth = token && req.url.includes(API_PREFIX) && !req.headers.has('Authorization');

      return next(needsAuth ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req);
    }),
  );
